/**
 * 体験授業申込みフォーム共通メソッド
 * 
 */
function trialFormCommon() {
	// メールドメインサジェスト機能(http://hacknote.jp/archives/1218/)
	// サジェスト一覧
	var availableTags = [
		 "yahoo.co.jp",
		 "gmail.com",
		 "icloud.com",
		 "ezweb.ne.jp",
		 "softbank.ne.jp",
		 "i.softbank.jp",
		 "d.vodafone.ne.jp",
		 "h.vodafone.ne.jp",
		 "t.vodafone.ne.jp",
		 "c.vodafone.ne.jp",
		 "k.vodafone.ne.jp",
		 "r.vodafone.ne.jp",
		 "n.vodafone.ne.jp",
		 "s.vodafone.ne.jp",
		 "q.vodafone.ne.jp",
		 "disney.ne.jp",
		 "emnet.ne.jp",
		 "wcm.ne.jp",
		 "outlook.jp",
		 "outlook.com",
		 "hotmail.co.jp",
		 "live.jp",
		 "infoseek.jp",
		 "excite.co.jp",
		 "inter7.jp",
		 "smoug.net",
		 "aol.jp",
		 "youngpostman.net",
		 "tora.zzn.com",
		 "zoho.com",
		 "goo.jp",
		 "mail.goo.ne.jp",
		 "auone.jp",
		 "livedoor.com",
		 "docomo.ne.jp"
	];
	// @以降の文字数を返す
	function extractLast(val) {
		if (val.indexOf("@") != -1) {
			var tmp = val.split("@");
			return tmp[tmp.length - 1];
		}
		return "";
	}
	// メールドメインサジェスト本体
	$(".domain-autocomplete")
	.bind("keydown").autocomplete({
				minLength : 1,
				source : function(request, response) {
					// @以降の文字を取得
					var mail = extractLast(request.term);
					if (mail.length < 1) {
						return;
					}
					// 候補リストと先頭+大文字小文字無視で突合せし
					// マッチしたものに@以前を付与して返却
					var matcher = new RegExp("^" + mail, "i");
					var ret = [];
					$.each($.grep(availableTags, function(item) {
						return matcher.test(item);
					}), function () {
						ret.push(request.term.substring(0, request.term.indexOf('@') + 1) + this);
					});
					response(ret);
				},
				focus : function() {
					// フォーカス時はサジェストしない
					return false;
				},
				select : function(event, ui) {
					this.value = ui.item.value;
					return false;
				}
			});

	$(document).on('click', '.js-add-cart', function(){
		setTimeout($.proxy(function(){
			if ($(this).is(':checked')) {
				var sendUrl = "/cart/add/";
			} else {
				var sendUrl = "/cart/delete/";
			}
			
			var data = {
				'kousha' : {
					'kousha_id' : $(this).attr('kousha_id')
				},
				'tutor_pref' : {
					'tutor_id' : $(this).attr('tutor_id'),
					'pref_cd' : $(this).attr('pref_cd')
				},
				'list_name' : $(this).attr('list_name'),
				'index' : $(this).attr('list_position'),
			};
			
			$.ajax({
				type: "POST",
				url: sendUrl,
				data: {
					is_json: 1,
					json_data : JSON.stringify(data)
				},
				dataType: "json"
			});
		}, this), 1000);
	});
	
	//【PC・SP共通】
	//フォームの項目が更新される度にストレージの内容も更新
	$('form[id=trialConfirmForm]').on('change',function(){
		var strageData = {};
		var formData = $(this).serializeArray();
		formData.forEach(function(item,index){
			//フォームのtrialに関する項目であればstorageへ保存する
			var matchData = item.name.match(/trial\[(.*)\]/);
			if(matchData !== null && matchData.length >= 2){
				strageData[item.name] = item.value;
			}
		});
		//localStorageがない場合は何もしない
		try{
			localStorage.setItem('trial', JSON.stringify(strageData));
		}catch(e){
			
		}
	});
}
/**
 * LocalStorageからフォームの情報を取得する
 * ※localStorageがなければnullを返す
 */
function getLocalStorageFormData(key){
	try{
		return JSON.parse(localStorage.getItem(key));
	}catch(e){
		return null
	}
}

/**
 * ページロード後に処理を走らせる
 */
$(function(){
	trialFormCommon();
});